<vl-spinner id="projects" [show]="spinnerVisible"></vl-spinner>
<mat-sidenav-container class="sidebar-container-with-toolbar">
    <mat-sidenav-content>
        <ng-container *ngIf="displayedContent === 'users'">
            <app-user></app-user>
        </ng-container>
        <ng-container *ngIf="displayedContent === 'roles'">
            <app-role></app-role>
        </ng-container>
        <ng-container *ngIf="displayedContent === 'dashboard'">

            

            <div class="mat-container" >
                <div class="page-header">
                    <div class="header-start">
                        <h2 class="title">Projects</h2>
                    </div>
                    @if([appPermissions.createProject , permissionsActions.edit] | apppermissions){
                        <div class="header-end" *ngIf="customerProjectListData.length == 0">
                            <button   mat-raised-button color="primary" (click)="createProjectDialog()">
                                <mat-icon>add</mat-icon> Create Project
                            </button>
                        </div>
                    }
                </div>

                <div class="row g-3 g-xxl-4 mb-4" *ngIf="customerProjectListData.length>0">
                    @if(  [appPermissions.createProject , permissionsActions.edit] | apppermissions ){
                        <div class="col-sm-6 col-lg-3 col-xxl-2" >
                            <mat-card mat-ripple class="mat-custom-card project-mat-card create" (click)="createProjectDialog()">
                                <mat-icon>add</mat-icon> <span>Create Project</span>
                            </mat-card>
                        </div>
                    }

                    
            <div class="col-sm-6 col-lg-3 col-xxl-2" *ngFor="let item of customerProjectListData">
                <mat-card mat-ripple class="mat-custom-card project-mat-card"
                    (click)="onProjectCardClick(item, item.project_id, item.project_name)">
            
                    <!-- Copy icon (top-right, hover-only) -->
                    @if([appPermissions.CopyProject, permissionsActions.edit] | apppermissions){
                        <div class="copy-icon-wrapper" matTooltip="Copy Project" (click)="copyApplication(item.project_id); $event.stopPropagation();">
                            <mat-icon class="copy-icon">content_copy</mat-icon>
                        </div>
                    }
            
                    <div class="image-container project-level-card">
                        <img [src]="item.image" alt="" class="project-logo">
                        <div class="modified-on">Last Modified: {{ formatLastModified(item.last_modified_date) }}</div>
                    </div>
            
                    <mat-card-content>
                        <mat-card-title [matTooltip]="item.project_name" class="ellipsis-input">
                            {{ item.project_name }}
                        </mat-card-title>
                        <mat-card-subtitle class="ellipsis-input">
                            {{ item.project_description }}
                        </mat-card-subtitle>
                    </mat-card-content>
            
                    <mat-card-actions class="d-flex justify-content-between">
                        <button mat-button color="warn"
                            *ngIf="[appPermissions.deleteProject, permissionsActions.edit] | apppermissions"
                            (click)="deleteProject(item.project_id); $event.stopPropagation();">
                            <mat-icon>delete</mat-icon> Delete</button>
            
                        <span class="flex-fill"></span>
            
                        <button mat-button *ngIf="[appPermissions.editProject, permissionsActions.edit] | apppermissions"
                            (click)="editProjectDialog(item); $event.stopPropagation();">
                            <mat-icon>edit</mat-icon>Edit
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>

                </div>
                <div class="container-no-project" *ngIf="!spinnerVisible && customerProjectListData.length === 0">

                    <span class="title">😎 No Projects Found</span>
                </div>
            </div>
        </ng-container>
    </mat-sidenav-content>
</mat-sidenav-container>